import { Nav } from "./Nav";

export const Header = () => {
    return (
        <header className="header">
            <Nav />
        </header>
    );
};